<!-- Translated: yes -->
<template>
  <div class="component">
    <button @click="cancel()">{{ $t('general.cancel') }}</button>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import TimeoutModal from '@/components/modals/TimeoutModal';

export default {
  props: {
    cancelPath: {
      default: '/pa-plats',
    },
  },
  components: {
    TimeoutModal,
  },
  data() {
    return {
      seconds: 0,
      inactivitySeconds: 60,
      inactivityLeft: 60,
      resetSeconds: 120,
      resetSecondsLeft: 120,
      intervalRef: null,
      showTimeoutModal: false,
    };
  },
  created() {
    window.addEventListener('mousemove', this.resetTimer);
    window.addEventListener('click', this.resetTimer);
    window.addEventListener('keyup', this.resetTimer);
    window.addEventListener('terminaltexts', this.resetTimerAndClose);
    window.addEventListener('paysuccess', this.resetTimerAndClose);
    window.addEventListener('payfail', this.resetTimerAndClose);
    window.addEventListener('syncing', this.resetTimerAndClose);
    window.addEventListener('syncprogress', this.resetTimerAndClose);
    window.addEventListener('syncsuccess', this.resetTimerAndClose);
    this.startTimer();
  },
  destroyed() {
    window.removeEventListener('mousemove', this.resetTimer);
    window.removeEventListener('click', this.resetTimer);
    window.removeEventListener('keyup', this.resetTimer);
    window.removeEventListener('terminaltexts', this.resetTimerAndClose);
    window.removeEventListener('paysuccess', this.resetTimerAndClose);
    window.removeEventListener('payfail', this.resetTimerAndClose);
    window.removeEventListener('syncing', this.resetTimerAndClose);
    window.removeEventListener('syncprogress', this.resetTimerAndClose);
    window.removeEventListener('syncsuccess', this.resetTimerAndClose);
    this.clearTimer();
  },
  mounted() {
  },
  methods: {
    ...mapMutations([
      'clearCart',
      'openModal',
      'openTimeoutModal',
      'closeTimeoutModal',
      'closeModal',
      'closeAllModals',
    ]),
    startTimer() {
      const $this = this;
      $this.intervalRef = setInterval(() => {
        $this.inactivityLeft -= 1;
        if ($this.inactivityLeft < 0) {
          $this.resetSecondsLeft -= 1;
          this.openTheModal();
        }
        if ($this.resetSecondsLeft < 0) {
          $this.cancelWithoutConfirmation();
        }
      }, 1000);
    },
    clearTimer() {
      clearInterval(this.intervalRef);
    },
    resetTimer() {
      while (this.inactivityLeft < this.inactivitySeconds) {
        this.inactivityLeft += 1;
      }
      while (this.resetSecondsLeft < this.resetSeconds) {
        this.resetSecondsLeft += 1;
      }
    },
    resetTimerAndClose() {
      this.resetTimer();
      this.closeTimeoutModal();
    },
    openTheModal() {
      this.openTimeoutModal(['TimeoutModal', {
        seconds: this.secondsLeftBeforeCancel,
        cancel: this.cancel,
        continue: this.resetTimerAndClose,
        inactive: this.isInactive,
        zIndex: 100015,
      }]);
    },
    secondsLeftBeforeCancel() {
      return this.resetSecondsLeft;
    },
    isInactive() {
      return this.inactivityLeft < 0;
    },
    cancelWithoutConfirmation() {
      this.closeAllModals();
      this.closeTimeoutModal();
      this.clearCart();

      const evt = document.createEvent('CustomEvent');
      evt.initCustomEvent('cancelpay', true, true, { });
      document.dispatchEvent(evt);

      this.$router.replace({
        path: this.cancelPath,
        query: {
          site: this.$store.state.isOnWhichSite,
          refresh: 1,
        },
      });
    },
    cancel() {
      const $this = this;
      this.openModal(['GeneralModal', {
        zIndex: 20,
        title: this.$i18n.t('general.cancel-booking-question-title'),
        content: this.$i18n.t('general.cancel-booking-question-text'),
        yes: () => {
          $this.closeAllModals();
          $this.closeTimeoutModal();
          $this.clearCart();

          const evt = document.createEvent('CustomEvent');
          evt.initCustomEvent('cancelpay', true, true, { });
          document.dispatchEvent(evt);

          $this.$router.replace({
            path: $this.cancelPath || '/pa-plats',
            query: {
              site: $this.$store.state.isOnWhichSite,
              refresh: 1,
            },
          });
        },
        no: () => {
          $this.closeTimeoutModal();
          $this.closeModal();
        },
      }]);
    },
  },
};
</script>

<style lang="stylus" scoped>
.component
  position: fixed
  bottom 0
  right 0
  background-color white
  padding 10px 10px
  border-top-left-radius: 5px
  z-index 10
</style>



// WEBPACK FOOTER //
// OnSiteFooter.vue?72ce2b82